import { useState, useEffect, useCallback } from 'react'

function useIsMobile(threshold = 575) {
  const [isMobile, setIsMobile] = useState<boolean>(
    window.innerWidth <= threshold,
  )

  const handleWindowSizeChange = useCallback(() => {
    setIsMobile(window.innerWidth <= threshold)
  }, [threshold])

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [handleWindowSizeChange])

  return isMobile
}

export default useIsMobile
